
import { EventBus, TypeEventBus } from '../../utils';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from '../Generics/Button.vue'
import InputText from '../Generics/InputText.vue'
import { PolygonTool } from '../../../tenants/types';
@Component({
    components: {
        Button,
        InputText
    }
})
export default class ItemActions extends Vue {
  @Prop({default: false}) polygonHasCoordinates: boolean
  /** Herramientas habilitadas por el tenant (`pages.item.polygonTools`). */
  @Prop({default: () => []}) tools!: PolygonTool[];
  readonly PolygonTool = PolygonTool;

  hasTool(tool: PolygonTool): boolean {
    return this.tools.includes(tool);
  }
   disabledHandDrawing: boolean = false;


   @Emit()
   drawPolygon(){
    this.disabledHandDrawing = true;
   }

   @Emit()
   createPolygonFromCoordinates(){
    EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION);
   }

   @Emit()
   fromPreloadedPolygons(){
    EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION)
   }

   @Emit()
   pointSearch(){
    EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION)
   }

   @Emit()
   uploadFile(){
    EventBus.$emit(TypeEventBus.CANCEL_POLYGON_EDITION)
   }

   mounted(){
     EventBus.$on(TypeEventBus.HAND_WRITING_DISABLED_BUTTON, (value) => {
       this.disabledHandDrawing = value;
     })
   }

}
